export enum InputType {
  Text = 'text',
  Time = 'time'
}
